import { useEffect } from "react";
import { Form } from "antd";
import { useAtom } from "jotai";
import {
	frmPreguntasRelacionesInterpersonalesAtom,
	puntajeTotalRelacionesInterpersonalesAtom,
} from "../../BandejaEvaluacionStorage";

const usePreguntasRelacionesInterpersonales = () => {
	const [puntajeTotal, setPuntajeTotal] = useAtom(puntajeTotalRelacionesInterpersonalesAtom);
	const [frmPreguntas, setFrmPreguntas] = useAtom(frmPreguntasRelacionesInterpersonalesAtom);
	const [form] = Form.useForm();

	useEffect(() => {
		if (!frmPreguntas) {
			setFrmPreguntas(form);
		}
	}, []);

	return { frmPreguntas, puntajeTotal, setPuntajeTotal };
};

export default usePreguntasRelacionesInterpersonales;
